/* Keep retired collection filters from hiding products through old links. */
(() => {
  const restoreCollection = event => {
    const url = new URL(window.location.href);
    if (!/(^|\/)collections\/[^/]+\/?$/.test(url.pathname)) return;

    // Legacy discipline views shared unrelated collections. Keep old links useful.
    const disciplineKeys = 'trail-riding,barrel-racing,team-roping,western-pleasure,working-ranch,reined-cow,reining,cutting,western-trail,western-horsemanship,pole-bending,breakaway-roping'.split(',');
    const view = url.searchParams.get('view') || '';
    const key = view.startsWith('discipline-') ? view.slice('discipline-'.length) : '';
    if (disciplineKeys.includes(key)) {
      const nextPath = url.pathname.replace(/collections\/[^/]+\/?$/, `collections/${key}-saddle-pads`);
      if (nextPath !== url.pathname) {
        url.pathname = nextPath;
        url.searchParams.delete('view');
        url.searchParams.delete('page');
        url.searchParams.delete('section_id');
        event?.stopImmediatePropagation();
        window.location.replace(url.href);
        return;
      }
    }

    let changed = false;
    for (const name of ['filter.v.availability', 'filter.v.price.gte', 'filter.v.price.lte']) {
      if (url.searchParams.has(name)) {
        url.searchParams.delete(name);
        changed = true;
      }
    }
    if (!changed) return;

    // Restart pagination after restoring the broader collection. Keep sort,
    // size/color selections, locale, draft preview and template parameters.
    url.searchParams.delete('page');
    event?.stopImmediatePropagation();
    window.location.replace(url.href);
  };

  // Capture history navigation before Flow fetches the retired filter state.
  window.addEventListener('popstate', restoreCollection, true);
  restoreCollection();
})();
